var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},_vm._l((_vm.cards),function(card){return _c('div',{key:card.id,staticClass:"cardItem",class:[
      _vm.floating && (card.id % 2 === 0 ? 'floatUp' : 'floatDown'),
      card.id === _vm.currentShowOutId && 'showOut'
    ],on:{"click":function($event){return _vm.handleTap(card.id)}}},[_c('div',{staticClass:"cardFace",style:(_vm.cardFrontBgStyle)}),_c('div',{staticClass:"cardFace",style:(_vm.cardBackBgStyle)})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }